var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkbox"},[_c('v-checkbox',_vm._b({attrs:{"value":_vm.value,"ripple":_vm.ripple,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();_vm.$props.click && _vm.$props.click()}}},'v-checkbox',_vm.$props,false),[_vm._t("label",null,null,_vm.$props)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }